.tableHeader {
  word-break: normal;
}
